module.exports = __webpack_public_path__ + "img/arrow.e623002e.svg";